export function getQueryElement(state) {
  if (state.indexSource.value === 'componentBasic') {
    return document.querySelector('prequal-app').shadowRoot;
  }
  if (state.indexSource.value === 'componentButton') {
    return document.querySelector('prequal-app-modal').shadowRoot;
  }
  return document;
}
